{
  "category": "Categoría {{count}}",
  "categories": {
    "1": "Emisiones directas de operaciones propias/controladas.",
    "2": "Emisiones indirectas provenientes del uso de electricidad adquirida, vapor, calefacción y refrigeración.",
    "3": "Emisiones indirectas de GEI por transporte tercerizado.",
    "4": "Emisiones indirectas de GEI por productos utilizados por la organización.",
    "5": "Emisiones indirectas de GEI asociadas con el uso de productos de la organización.",
    "6": "Emisiones indirectas de GEI por otras fuentes.",
    "7": "Emisiones indirectas de GEI no clasificadas."
  },
  "scope": "Alcance {{count}}",
  "scopes": {
    "1": "Emisiones directas de operaciones propias/controladas.",
    "2": "Emisiones indirectas provenientes del uso de electricidad adquirida, vapor, calefacción y refrigeración.",
    "3": "Emisiones indirectas provenientes de otras fuentes."
  },
  "sources": {
    "COMBUSTIBLES": "Combustibles",
    "EXTINGUISHERS_AND_REFRIGERANTS": "Extintores y refrigerantes",
    "ELECTRICITY": "Energía eléctrica",
    "TRANSPORT": "Transporte Tercerizado",
    "RAW_MATERIALS": "Bienes y servicios adquiridos",
    "WASTE": "Residuos",
    "WATER": "Suministro de agua",
    "FERTILIZERS": "Fertilizantes",
    "AGRICULTURE": "Agropecuario",
    "LEAKS_AND_PROCESSES": "Fugas y procesos",
    "FRANCHISES":"Franquicias",
    "UP_WATER": "Transporte de bienes y servicios (Aguas arriba)",
    "DOWN_WATER": "Transporte aguas abajo",
    "COMBUSTIBLES_ACTIVITIES": "Actividades de combustible"
  },
  "types": {
    "DIRECT": "Emisiones directas",
    "PRICE": "Precio",
    "EFFICIENCY": "Eficiencia",
    "EXTINGUISHERS": "Extintores",
    "REFRIGERANT_LEAKS": "Fugas de gases refrigerantes",
    "ELECTRICITY": "Consumo de energía eléctrica",
    "INDIRECT_TRANSPORT": "Emisiones Indirectas - Transporte de carga",
    "INDIRECT_TRANSPORT_COLLABORATORS": "Emisiones Indirectas - Transporte colaboradores (Ruta)",
    "RAW_MATERIALS": "Bienes y servicios adquiridos",
    "WASTE": "Tratamiento de residuos sólidos",
    "WATER": "Consumo de agua",
    "NITROGEN_FERTILIZER": "Fertilizantes nitrogenados",
    "CALCIUM_FERTILIZER": "Fertilizantes de cal",
    "UREA_FERTILIZER": "Fertilizantes de urea",
    "MANURE": "Manejo de estiércol",
    "ENTERIC_FERMENTATION": "Fermentación entérica",
    "FLIGHTS": "Vuelos",
    "UP_WATER": "Transporte de bienes y servicios (Aguas arriba)",
    "DOWN_WATER": "Aguas abajo",
    "LEAKS": "Fugas",
    "COMBUSTIBLES_ACTIVITIES": "Actividades de combustible",
    "BUSINESS_TRAVEL": "Viajes de negocios"
  },
  "variations": {
    "FIXED": "Combustión estacionaria",
    "MOBILE": "Combustión móvil",
    "OTHERS": "Otras",
    "BUSINESS_TRAVEL": "Viajes de negocios",
    "PROCESS": "Fuentes de proceso",
    "ENERGY": "Energía",
    "FUGITIVE": "Fuentes fugitivas",
    "FRANCHISES": "Franquicias",
    "RAW_MATERIALS": "Bienes y servicios adquiridos",
    "UP_WATER": "Transporte de bienes y servicios (Aguas arriba)",
    "DOWN_WATER": "Transporte aguas abajo",
    "TRANSPORT_WORKERS": "Traslado de empleados",
    "WASTE": "Residuos",
    "COMBUSTIBLES_ACTIVITIES": "Actividades de combustible"
  },
  "references": {
    "SOLID": "Combustibles sólidos",
    "GAS": "Combustibles gaseosos",
    "LIQUID": "Combustibles líquidos",
    "SOLID_PRICE": "Combustibles sólidos por precio",
    "GAS_PRICE": "Combustibles gaseosos por precio",
    "LIQUID_PRICE": "Combustibles líquidos por precio",
    "SOLID_PRICE_ANUAL": "Combustibles sólidos por precio anual",
    "GAS_PRICE_ANUAL": "Combustibles gaseosos por precio anual",
    "LIQUID_PRICE_ANUAL": "Combustibles líquidos por precio anual",
    "REFRIGERANT_LEAKS": "Fugas de refrigerantes - Conoce la fuga",
    "ESTIMATED_REFRIGERANT_LEAKS": "Fugas de refrigerantes - No conoce la fuga",
    "UNITS": "Unidades",
    "CYCLES": "Ciclos",
    "TRANSMISSION": "Perdidas de distribución y transmisión",
    "REMOTE_WORK": "Teletrabajo",
    "NO_CONVENTIONAL": "Emisiones evitadas por energía no convencional",
    "WASTE_RECOVERY": "Emisiones evitadas por aprovechamiento de residuos",
    "ELECTRIC_VEHICLES": "Emisiones evitadas por vehículos eléctricos",
    "PASSENGERS_MONTHLY": "Pasajeros mensuales",
    "PASSENGERS_ONCE": "Pasajeros por viaje",
    "UP_WATER_SOLID": "Transporte (km*ton)",
    "DOWN_WATER": "Aguas abajo",
    "DISTANCE": "Vuelos por distancia",
    "GAS_LEAKS": "Fugas de gas GEI",
    "RAW_MATERIALS": "Bienes y servicios adquiridos",
    "RAW_MATERIALS_USD": "Bienes y servicios adquiridos (USD)",
    "AIR_TRAVEL": "Viajes aéreos",
    "LUBRICANTS": "Uso de lubricantes",
    "LOSSES_CATEGORY": "Pérdidas T&D (solo aplica para distribuidores en esta categoría)",
    "LOSSES": "Pérdidas de transmisión y distribución (T&D)",
    "EXTINGUISHERS": "Extintores",
    "GAS_SYSTEM_LEAKS": "Fugas en sistemas de gas",
    "CONSUMPTION": "Energía del SIN",
    "GAS_SYSTEM_VENTS": "Venteos en sistemas de gas",
    "FRANCHISES": "Franquicias",
    "GAS_TRANSPORT_SOLD": "Transporte de productos vendidos (combustibles gaseosos)",
    "TRIPS": "Viajes",
    "WASTE_SOLID": "Tratamiento de residuos sólidos",
    "UP_WATER_COMBUSTIBLES": "Emisiones aguas arriba de combustibles adquiridos",
    "UP_WATER_ELECTRICITY": "Emisiones aguas arriba de electricidad adquirida"
  },
  "no-category": "Sin categoría",
  "method": {
    "title": "Metodología",
    "byElement": "Por consumo",
    "byGases": "Por gases",
    "byLeaks": "Por fugas",
    "byEquivalence": "Por conversión",
    "byCycles": "Por ciclos"
  }
}
